module.exports = __webpack_public_path__ + "img/categories_grey_border.4846735a.svg";